import React from 'react';
import { StyledHeaderContainer } from '../../../PlusWebsiteEditor/PlusWebsiteEditor.styles';

interface CreateClinicHeaderProps {
  title?: string;
}

const CreateClinicHeader: React.FC<CreateClinicHeaderProps> = ({ title = 'Clinic Settings' }) => {
  return (
    <StyledHeaderContainer>
      <h2>{title}</h2>
    </StyledHeaderContainer>
  );
};

export default CreateClinicHeader;
